/* FreshSmile product page scripts: variant picker, gallery, zoom, sticky add-to-cart. */
(function () {
  'use strict';

  var productEl = document.querySelector('[data-product]');
  if (!productEl) return;

  var strings = {};
  var stringsEl = document.querySelector('[data-theme-strings]');
  if (stringsEl) {
    try { strings = JSON.parse(stringsEl.textContent); } catch (e) { strings = {}; }
  }
  function t(key, fallback) { return strings[key] || fallback || ''; }

  var variants = [];
  var variantsEl = document.querySelector('[data-product-variants]');
  if (variantsEl) {
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
  }

  var form = document.querySelector('form[data-product-form]');
  var idInput = form && form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-product-price]');
  var stockEl = document.querySelector('[data-stock-status]');
  var atcButton = document.querySelector('[data-atc-button]');
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyButton = document.querySelector('[data-sticky-atc-button]');

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = document.body.getAttribute('data-money-format') || '${{amount}}';
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function selectedOptions() {
    var options = [];
    document.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      if (checked) options[parseInt(fieldset.getAttribute('data-option-index'), 10)] = checked.value;
    });
    return options;
  }

  function findVariant(options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === options[index]; });
    });
  }

  function renderPrice(variant) {
    if (!priceEl) return;
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html = '<ins>' + formatMoney(variant.price) + '</ins> <del>' +
        '<span class="visually-hidden">' + (priceEl.getAttribute('data-regular-label') || '') + '</span>' +
        formatMoney(variant.compare_at_price) + '</del>';
    } else {
      html = formatMoney(variant.price);
    }
    priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
  }

  function renderAvailability(variant) {
    var available = variant && variant.available;
    [atcButton, stickyButton].forEach(function (button) {
      if (!button) return;
      button.disabled = !available;
      button.textContent = available ? t('addToCart', 'Add to cart') : t('soldOut', 'Sold out');
    });
    if (stockEl) {
      stockEl.classList.toggle('is-soldout', !available);
      stockEl.textContent = available
        ? stockEl.getAttribute('data-label-in-stock')
        : stockEl.getAttribute('data-label-soldout');
    }
  }

  function updateGalleryForVariant(variant) {
    if (!variant || !variant.featured_media_id) return;
    var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + variant.featured_media_id + '"]');
    if (thumb) thumb.click();
  }

  function onVariantChange() {
    var variant = findVariant(selectedOptions());
    if (!variant) {
      [atcButton, stickyButton].forEach(function (button) {
        if (!button) return;
        button.disabled = true;
        button.textContent = t('unavailable', 'Unavailable');
      });
      return;
    }
    if (idInput) idInput.value = variant.id;
    renderPrice(variant);
    renderAvailability(variant);
    updateGalleryForVariant(variant);
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  document.querySelectorAll('[data-option-index] input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', onVariantChange);
  });

  /* --- Gallery ------------------------------------------------------------- */
  var mainWrap = document.querySelector('[data-gallery-main]');
  var mainImg = mainWrap && mainWrap.querySelector('img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.srcset = thumb.getAttribute('data-srcset') || '';
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
        other.setAttribute('aria-current', 'false');
      });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* --- Zoom ---------------------------------------------------------------- */
  if (mainWrap && mainWrap.classList.contains('is-zoomable') && mainImg) {
    mainWrap.addEventListener('click', function (event) {
      var zoomed = mainWrap.classList.toggle('is-zoomed');
      if (zoomed) {
        var rect = mainWrap.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      } else {
        mainImg.style.transformOrigin = '';
      }
    });
    mainWrap.addEventListener('mousemove', function (event) {
      if (!mainWrap.classList.contains('is-zoomed')) return;
      var rect = mainWrap.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
    mainWrap.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        mainWrap.classList.remove('is-zoomed');
        mainImg.style.transformOrigin = '';
      }
    });
  }

  /* --- Sticky add-to-cart bar (mobile) --------------------------------------- */
  if (stickyBar && form) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    observer.observe(form);

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (atcButton && !atcButton.disabled) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
    }
  }
})();
